import { createContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import UserFeaturesContext from './UserFeaturesContext';
import { FEATURE_NAME } from '../../components/DoctorMangement/constant';
import { LOCAl_STORAGE_KEY_VALID_SERVICES, SERVICE_NAME_LABS, SERVICE_NAME_OFFLINE_CONSULTS } from '../../constants/provider/constant';
import {getDepartmentsFromRoles} from '../../helper/utils';

const UserFeaturesProvider = ({ children }) => {
    const [userFeatures, setUserFeatures] = useState();
    const [OFCSpeciality, setOFCSpeciality] = useState();

    const saveUserFeatures = async (userFeature, userRoles) => {
        if(userFeature && userFeature.length ===0 ){
            setUserFeatures([]);
        }
        //set valid services on reload
        const validService =[];
        if(userFeature?.includes(FEATURE_NAME.VIEW_OFFLINE)){
            validService.push(SERVICE_NAME_OFFLINE_CONSULTS);
        }
        if(userFeature?.includes(FEATURE_NAME.VIEW_LABS)) {
            validService.push(SERVICE_NAME_LABS)
        }
        localStorage.setItem(LOCAl_STORAGE_KEY_VALID_SERVICES, JSON.stringify(validService));

        const {labSelectedDepartment, OFCselectedDepartment} = getDepartmentsFromRoles(userRoles);
        setOFCSpeciality(OFCselectedDepartment);
        setUserFeatures(userFeature);
    };

    return (
        <UserFeaturesContext.Provider value={{ userFeatures, saveUserFeatures, OFCSpeciality }}>
            {children}
        </UserFeaturesContext.Provider>
    );
};

export default UserFeaturesProvider;
